module.exports = __webpack_public_path__ + "rw.b4301797e4f428bf0e23.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/rw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/rw.svg
// module chunks = styles